import { render, staticRenderFns } from "./KFocusTrap.vue?vue&type=template&id=e5847192&scoped=true"
import script from "./KFocusTrap.vue?vue&type=script&lang=js"
export * from "./KFocusTrap.vue?vue&type=script&lang=js"
import style0 from "./KFocusTrap.vue?vue&type=style&index=0&id=e5847192&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5847192",
  null
  
)

export default component.exports